import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export function getTransactionVendorDetails(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getVendorDetails/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorSubsidiaries(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getVendorSubsidiaries${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorAddress(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getVendorAddress${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorCurrencies(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getVendorCurrencies${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorPreferences(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getVendorPreferences/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorOpenair(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getVendorOpenair/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionVendorTransactions(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getVendorTransactions${q}`, {
    headers: {
      authorization: token,
    },
  });
}

{/*customer*/ }

export function getTransactionCustomerDetails(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerDetails/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerAddress(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerAddress${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerQualification(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerQualification/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerMarketing(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerMarketing/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerFinancial(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerFinancial/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerCurrencies(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerCurrencies${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerPreferences(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerPreferences/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerCustom(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerCustom/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerOpenair(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerOpenair/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerAvatax(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerAvatax/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerSubsidiaries(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerSubsidiaries${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerItemsPurchased(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerItemsPurchased${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerUpsell(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerUpsell${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionCustomerTransactions(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCustomerTransactions${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectDetails(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getProjectDetails/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectResourceAllocation(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getResourceAllocation${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectResourceDetails(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getResourceDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectTimeTracking(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getTimeTracking${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectTasks(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getProjectTasks${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectBillingInfo(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getBillingInfo/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionPercentCompleteOverride(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getPercentCompleteOverride${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectCharges(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getCharges${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectContacts(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getContacts${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectSubProjects(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getSubProjects${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectActivities(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getActivities${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectFiles(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getFiles${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectMessages(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getMessages${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionExpenseReportPolicy(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getExpenseReportPolicy${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectPreferences(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getPreferences/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactionProjectOpenair(token, id) {
  //const q = buildQuery(query);
  return axios.get(`${baseUrl}/getOpenair/${id}`, {
    headers: {
      authorization: token,
    },
  });
}


